"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var DeleteChangesModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DeleteChangesModal, _PureComponent);

  function DeleteChangesModal() {
    (0, _classCallCheck2.default)(this, DeleteChangesModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeleteChangesModal).apply(this, arguments));
  }

  (0, _createClass2.default)(DeleteChangesModal, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation.save." + suffix;
    }
  }, {
    key: "formatedMessage",
    value: function formatedMessage(suffix) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey(suffix)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          onConfirm = _this$props.onConfirm,
          onCancel = _this$props.onCancel;
      if (!show) return null;
      return _react.default.createElement(_UIConfirmModal.default, {
        confirmUse: "danger",
        size: "auto",
        use: "danger",
        message: this.formatedMessage('deleteTitle'),
        description: this.formatedMessage('deleteBody'),
        confirmLabel: this.formatedMessage('deleteConfirm'),
        rejectLabel: this.formatedMessage('deleteCancel'),
        onConfirm: onConfirm,
        onReject: onCancel
      });
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        show: _react.PropTypes.bool,
        onConfirm: _react.PropTypes.func.isRequired,
        onCancel: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return DeleteChangesModal;
}(_react.PureComponent);

exports.default = DeleteChangesModal;
module.exports = exports.default;